import { logWarning } from '../utils/env';

const mimeTypes = {
  ALL: '*/*',

  IMAGE: 'image/*',
  AUDIO: 'audio/*',
  VIDEO: 'video/*',
  TEXT: 'text/*',


  APPLICATION_PDF: 'application/pdf',
  APPLICATION_JSON: 'application/json',
  APPLICATION_MS_EXCEL: 'application/vnd.ms-excel',
  APPLICATION_MS_EXCEL_OPEN_XML: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  APPLICATION_PUB: 'application/vnd.ms-publisher',
  APPLICATION_EPUB: 'application/epub+zip',
  APPLICATION_ODT: 'application/vnd.oasis.opendocument.text',
  APPLICATION_ZIP: 'application/zip',

  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  IMAGE_GIF: 'image/gif',
  IMAGE_BMP: 'image/bmp',


  TEXT_XML: 'text/xml',
  TEXT_HTML: 'text/html',
  TEXT_CSV: '.csv',
  TEXT_TXT: 'text/plain',

  VIDEO_MP4: 'video/mp4',
  VIDEO_M4V: 'video/m4v',
  VIDEO_MOV: 'video/quicktime',
};

const doc_dot = 'application/msword';
const docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const dotx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template';
const docm = 'application/vnd.ms-word.document.macroEnabled.12';
const dotm = 'application/vnd.ms-word.template.macroEnabled.12';
const word = [doc_dot, docx, dotx, docm, dotm];
const wordMimeTypeEnum = { doc_dot, docx, dotx, docm, dotm };

const excel = [
  'application/msexcel',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
];

const powerPoint = [
  'application/vnd.ms-powerpoint',
  'application/mspowerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.template.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
];

const mimeTypesByGroup = {
  word,
  excel,
  powerPoint
};

const imageMimeTypeExtensions = {
  'image/bmp': 'bmp',
  'image/cis-cod': 'cod',
  'image/gif': 'gif',
	'image/ief': 'ief',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
	'image/pipeg': 'jfif',
  'image/svg+xml': 'svg',
	'image/tiff': 'tiff',
  'image/x-cmu-raster': 'ras',
	'image/x-cmx': 'cmx',
  'image/x-icon': 'ico',
	'image/x-portable-anymap': 'pnm',
	'image/x-portable-bitmap': 'pbm',
	'image/x-portable-graymap': 'pgm',
	'image/x-portable-pixmap': 'ppm',
  'image/x-rgb': 'rgb',
  'image/x-xbitmap': 'xbm',
	'image/x-xpixmap': 'xpm',
 	'image/x-xwindowdump': 'xwd',

  webSupportedTypes: [
    'image/apng',
    'image/avif',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/webp',
  ],

  isImage(type) {
    return this.hasOwnProperty(type);
  },

  isWebSupportedImage(type) {
    return this.webSupportedTypes.includes(type);
  },

  getExtension(type) {
    if (this.hasOwnProperty(type)) {
      return this[type];
    }
    const defaultExt = this['image/jpeg'];
    logWarning(`Could not find ext for file type ${type}, default used: ${defaultExt}`);
    return defaultExt;
  }
};

// TODO: complete the ext list
const videoMimeTypeExtensions = {
  [mimeTypes.VIDEO_MP4]: ['mp4', 'm4a', 'm4p', 'm4b', 'm4r', 'm4v'],
  [mimeTypes.VIDEO_MOV]: ['mov', 'qt'],
  [mimeTypes.VIDEO_M4V]: ['m4v'],

  isVideo(type) {
    return this.hasOwnProperty(type);
  }

};

module.exports = {
  mimeTypes,
  mimeTypesByGroup,
  imageMimeTypeExtensions,
  videoMimeTypeExtensions,
  wordMimeTypeEnum
};
